// summaryArray.map((text) => {
//   const isBold = text.startsWith('<bold>');
//   let cleanText = text.replace(/<bold>/g, '');
//   if (isBold && accessor) {
//     if (accessor instanceof Function) {
//       cleanText = accessor(user);
//     } else {
//       cleanText = user[accessor];
//     }
//   }
//   return (
//     <Text weight={isBold && 'bold'} className="inline">
//       {cleanText}
//     </Text>
//   );
// });

const sanitizeArray = (textArray, accessor, content, additionalData) => textArray.map((text) => {
  const isBold = text.startsWith('<bold>');
  let cleanText = text.replace(/<bold>/g, '');
  if (isBold && accessor) {
    if (accessor instanceof Function) {
      cleanText = accessor(content, additionalData);
    } else {
      cleanText = content[accessor];
    }
  }
  return { isBold, text: cleanText };
});

const getTextArray = (text) => text
  .replace(/(?=<bold>(.*?)<\/bold>)/g, '___')
  .replace(/<\/bold>/g, '___')
  .split('___');

export default (text, accessor, content, additionalData) => {
  const summaryArray = getTextArray(text);
  return sanitizeArray(summaryArray, accessor, content, additionalData);
};
